import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

type InputProps = {
    anchor?: string;
    onClick: () => void;
};

export default function ForgotPasswordButton({
    anchor = "",
    ...props
}: InputProps) {
    const { t } = useTranslation();

    return (
        <div className="flex justify-center">
            <Button
                type="button"
                aria-label="Esqueci-me da palavra-passe. Por favor clique para recuperar a palavra-passe."
                variant={"link"}
                size={"link"}
                onClick={props.onClick}
            >
                {t("login_password_associated.forgot_password_message1")}
            </Button>
        </div>
    );
}
